import { z } from 'zod';

import { codec, useQueryParams } from '@/hooks/router/use-query-params';

export function useAlertsNavigation() {
  const [{ fullFrontendId, type, level }, queryParams] = useQueryParams({
    fullFrontendId: {
      key: 'fid',
      schema: z.string().optional(),
      codec: codec.string,
    },
    type: {
      key: 'type',
      schema: z.string().optional(),
      codec: codec.string,
    },
    level: {
      key: 'level',
      schema: z.string().optional(),
      codec: codec.string,
    },
  });

  const clearSelection = () => {
    queryParams.push({
      fullFrontendId: undefined,
      type: undefined,
      level: undefined,
    });
  };

  const selectAlert = (alert: {
    fullFrontendId: string;
    type: string;
    level: string;
  }) => {
    const { fullFrontendId, type, level } = alert;
    queryParams.push({ fullFrontendId, type, level });
  };

  return {
    fullFrontendId,
    type,
    level,
    clearSelection,
    selectAlert,
  };
}
